import styled from 'styled-components';

export const UiCloseButton = styled.div`
position: relative;
    width: 20px;
    height: 20px;
    right: -100%;
    transform: translateX(-20px);
    z-index: 1001;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    > .line1{
      transform: rotate(-45deg);
      background-color: #a1a4b1;
    width: 2px;
    height: 23px;
    position: absolute;
    transform-origin: center;
    }
    > .line2{
      transform: rotate(45deg);
      background-color: #a1a4b1;
    width: 2px;
    height: 23px;
    position: absolute;
    transform-origin: center;
    }
`
export const UiLogin = styled.div`
position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Microsoft JhengHei", "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    transition: opacity 0.5s;
    opacity: 1;
    overflow: hidden;
`
export const UiLoginBG = styled.div`
position: absolute;
top: 0px;
width: 100%;
height: 100%;
background-color: black;
opacity: 0.4;
pointer-events: auto;
`
export const UiMoeButton = styled.div`
width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #82b8c0;
  height: 36px;
  border-radius: 8px;
  > a{
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: white;
    line-height: 1.5;
    font-weight: 700;
  }
`
export const UiHr = styled.hr`
width: 100%;
    border: solid 1px rgba(145, 158, 171, 0.24);
    margin: 32px 0px;
`
export const UiNaniAccount = styled.div`
color: #454b5c;
    font-weight: 500;
    line-height: 24px;
    font-size: 14px;
`
export const UiTip = styled.div`
color: #919eab;
line-height: 24px;
    font-size: 14px;
`
export const UiLoginBox = styled.div`
min-width: 300px;
    max-width: 350px;
    width: 100%;
    padding: 18px;
    background-color: white;
    border-radius: 0.5rem;
    margin: auto;
    position: relative;
    z-index: 1001;
    > h5{
      width: 100%;
    text-align: center;
    color: #212b36;
    font-size: 22px;
    margin-right: 15px;
    padding-bottom: 24px;
    margin: 0;
    display: inline-block;
    border-bottom: 2px solid transparent;
    }
`
export const UiLoginContent = styled.div`
position: absolute;
top: 0px;
z-index:1000;
    width: 100%;
    padding: 18px;
    background-color: white;
    border-radius: 0.5rem;
    margin: auto;
    position: relative;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const UiInputAccount = styled.div`
width: 100%;
position: relative;
> img{
  position: absolute;
    left: 10px;
    top: 17.5px;
}
> div{
  margin: 10px 0;
  > label{
    > input{
      width: 100%;
    padding: 10px 5px 8px 40px;
    font-family: "Microsoft JhengHei", "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    border-radius: 5px;
    border: 1px solid #ccc;
    }
  }
}
`
export const UiLoginButton = styled.div`
background-color: #ec7963;
    border-color: #3d3d3d;
    margin-top: 15px;
    width: 100%;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #fff;
    padding: 0.75rem 0.85rem !important;
    border-radius: 8px !important;
    font-weight: 700;
    transition: 0.35s;
    height: 36px;
`
export const UiError = styled.div`
display: block;
    color: #dc3545;
    font-weight: 700;
    font-size: 0.7rem;
    height: 16px;
`